module.exports = __webpack_public_path__ + "static/Kinto_missing_information-9b4e08726b074aac29402c6d43dcdc82.jpg";